// eslint-disable-next-line import/no-named-as-default
import { PRIVACITY } from '@/febos/chile/dnt/config/constants/exp/privacity';

const filterViewsCompany = {
  '60100003-2': {
    general: {
      filtrosFijos: [
        {
          nombre: 'Es Documento Madre',
          campo: 'estadoCodigoEstadoComprador',
          tipo: 'text',
          valor: '1'
        }
      ],
      filtrosHabilitados: [
        { nombre: 'Autor', campo: 'doc_digital_autorusuario_autor_id', tipo: 'usuarioIds' },
        { nombre: 'Nombre del Exp.', campo: 'titulo', tipo: 'texto' },
        {
          nombre: 'Estado de propuesta',
          campo: 'transporteViaTransporteVehiculoPatente',
          tipo: 'multi',
          valor: [],
          opciones: {
            approved: 'Aprobada',
            'partial-approved': 'Aprobada parcial',
            rejected: 'Rechazada',
            retired: 'Retirada',
            'not-processed': 'No tramitada',
            inadmissible: 'Inadmisible'
          }
        }
      ],
      filtroFijoABorrar: ['general', 'estado']
    },
    borradores: {
      filtrosHabilitados: [
        { nombre: 'Autor', campo: 'doc_digital_autorusuario_autor_id', tipo: 'usuarioIds' }
      ]
    },
    pendientes: {
      filtrosHabilitados: [
        { nombre: 'Autor', campo: 'doc_digital_autorusuario_autor_id', tipo: 'usuarioIds' }
      ]
    },
    ingresados: {
      filtrosHabilitados: [
        { nombre: 'Autor', campo: 'doc_digital_autorusuario_autor_id', tipo: 'usuarioIds' }
      ]
    },
    completitudDatos: {
      filtrosHabilitados: [
        { nombre: 'Autor', campo: 'doc_digital_autorusuario_autor_id', tipo: 'usuarioIds' },
        { nombre: 'Nombre del Exp.', campo: 'titulo', tipo: 'texto' },
        {
          nombre: 'Estado de propuesta',
          campo: 'transporteViaTransporteVehiculoPatente',
          tipo: 'multi',
          valor: [],
          opciones: {
            approved: 'Aprobada',
            'partial-approved': 'Aprobada parcial',
            rejected: 'Rechazada',
            retired: 'Retirada',
            'not-processed': 'No tramitada',
            inadmissible: 'Inadmisible'
          }
        }
      ]
    },
    tramitados: {
      filtrosHabilitados: [
        { nombre: 'Autor', campo: 'doc_digital_autorusuario_autor_id', tipo: 'usuarioIds' }
      ]
    },
    finalizados: {
      filtrosHabilitados: [
        { nombre: 'Autor', campo: 'doc_digital_autorusuario_autor_id', tipo: 'usuarioIds' }
      ]
    },
    docDigital: {
      filtrosHabilitados: [
        { nombre: 'Autor', campo: 'doc_digital_autorusuario_autor_id', tipo: 'usuarioIds' }
      ]
    },
    compartido: {
      filtrosHabilitados: [
        { nombre: 'Autor', campo: 'doc_digital_autorusuario_autor_id', tipo: 'usuarioIds' }
      ]
    },
    generalSoporte: {
      filtrosHabilitados: [
        { nombre: 'Autor', campo: 'doc_digital_autorusuario_autor_id', tipo: 'usuarioIds' }
      ]
    }
  },
  '61221000-4': {
    general: {
      filtrosFijos: [
        {
          nombre: 'Es privado',
          campo: 'transportePuertoTipo', // es privado
          tipo: 'multi',
          valor: [],
          opciones: {
            [PRIVACITY.RESERVED]: 'Documento reservado',
            [PRIVACITY.CONFIDENTIAL]: 'Documento privado',
            [PRIVACITY.PUBLIC]: 'Documento público'
          }
        }
      ],
      filtrosHabilitados: [
        {
          nombre: 'Es privado',
          campo: 'transportePuertoTipo', // es privado
          tipo: 'multi',
          valor: [],
          opciones: {
            [PRIVACITY.RESERVED]: 'Documento reservado',
            [PRIVACITY.CONFIDENTIAL]: 'Documento privado',
            [PRIVACITY.PUBLIC]: 'Documento público'
          }
        }
      ]
    }
  },
  '61202000-0': {
    borradores: {
      filtrosHabilitados: [
        {
          nombre: 'Nº Contrato SAFI', campo: 'transportePuertoCodigo', tipo: 'texto', valor: []
        }
      ]
    },
    pendientes: {
      filtrosHabilitados: [
        {
          nombre: 'Nº Contrato SAFI', campo: 'transportePuertoCodigo', tipo: 'texto', valor: []
        }
      ]
    },
    tramitados: {
      filtrosHabilitados: [
        {
          nombre: 'Nº Contrato SAFI', campo: 'transportePuertoCodigo', tipo: 'texto', valor: []
        }
      ]
    },
    finalizados: {
      filtrosHabilitados: [
        {
          nombre: 'Nº Contrato SAFI', campo: 'transportePuertoCodigo', tipo: 'texto', valor: []
        }
      ]
    },
    general: {
      filtrosHabilitados: [
        {
          nombre: 'Nº Contrato SAFI', campo: 'transportePuertoCodigo', tipo: 'texto', valor: []
        }
      ]
    }
  },
  '61808000-5': {
    renombres: {
      solicitanteGrupoId: 'Unidad de Origen'
    },
    pendientes: {
      filtrosHabilitados: [
        {
          nombre: 'Tema',
          campo: 'transporteEmpresaTransporteInfoAdicional',
          tipo: 'theme'
        },
        {
          nombre: 'Subtema',
          campo: 'estadoDescripcionEstadoComprador',
          tipo: 'subTheme'
        }
      ]
    },
    tramitados: {
      filtrosHabilitados: [
        {
          nombre: 'Tema',
          campo: 'transporteEmpresaTransporteInfoAdicional',
          tipo: 'theme'
        },
        {
          nombre: 'Subtema',
          campo: 'estadoDescripcionEstadoComprador',
          tipo: 'subTheme'
        }
      ]
    },
    finalizados: {
      filtrosHabilitados: [
        {
          nombre: 'Tema',
          campo: 'transporteEmpresaTransporteInfoAdicional',
          tipo: 'theme'
        },
        {
          nombre: 'Subtema',
          campo: 'estadoDescripcionEstadoComprador',
          tipo: 'subTheme'
        }
      ]
    },
    borradores: {
      filtrosHabilitados: [
        {
          nombre: 'Tema',
          campo: 'transporteEmpresaTransporteInfoAdicional',
          tipo: 'theme'
        },
        {
          nombre: 'Subtema',
          campo: 'estadoDescripcionEstadoComprador',
          tipo: 'subTheme'
        }
      ]
    },
    'pendientes-unidad': {
      filtrosHabilitados: [
        {
          nombre: 'Tema',
          campo: 'transporteEmpresaTransporteInfoAdicional',
          tipo: 'theme'
        },
        {
          nombre: 'Subtema',
          campo: 'estadoDescripcionEstadoComprador',
          tipo: 'subTheme'
        }
      ]
    },
    general: {
      filtrosHabilitados: [
        {
          nombre: 'Plazo de gestión', campo: 'fechaVencimiento', tipo: 'fecha', valor: ''
        },
        {
          nombre: 'Enviado a Open Text',
          campo: 'enviadoOpenText',
          tipo: 'multi',
          opciones: {
            Y: 'Si',
            N: 'No'
          }
        },
        {
          nombre: 'Tema',
          campo: 'transporteEmpresaTransporteInfoAdicional',
          tipo: 'theme'
        },
        {
          nombre: 'Subtema',
          campo: 'estadoDescripcionEstadoComprador',
          tipo: 'subTheme'
        }
      ],
      filtrosHabilitadosABorrar: [
        'transporteViaTransporteCodigoTransporte',
        'claseMercadoPublico',
        'transporteViaTransporteCodigoTransporte',
        'destinoCodigoIds',
        'codigosReferenciasTipos',
        'emisorContactoNombre',
        'emisorContactoCargo',
        'emisorContactoEmail',
        'destinoCorreoIds',
        'codigosDerivacionUsuario',
        'compradorCodigo',
        'destinoParticipanteIds',
        'destinoParticipanteIds',
        'aprParticipante'
      ]
    }
  },
  '72235100-2': {
    general: {
      filtrosHabilitados: [
        {
          nombre: 'Tipo de remitente',
          campo: 'compradorArea',
          tipo: 'multi',
          valor: [],
          opciones: {
            CIU: 'Ciudadano/a',
            PROV: 'Proveedores',
            PJU: 'Persona Jurídica',
            OES: 'Organismo del estado'
          }
        },
        {
          nombre: 'Institución remitente',
          campo: 'emisorContactoArea',
          tipo: 'texto',
          valor: [],
        }
      ],
    },
    files: {
      filtrosHabilitados: [
        {
          nombre: 'Tipo de remitente',
          campo: 'compradorArea',
          tipo: 'multi',
          valor: [],
          opciones: {
            CIU: 'Ciudadano/a',
            PROV: 'Proveedores',
            PJU: 'Persona Jurídica',
            OES: 'Organismo del estado'
          }
        }
      ],
    }
  },
};
const filterViews = {
  borradores: {
    filtrosFijos: [
      {
        nombre: 'Rut emisor',
        campo: 'emisorRut',
        tipo: 'text',
        // eslint-disable-next-line no-template-curly-in-string
        valor: '${iutEmpresa}'
      },
      {
        nombre: 'Responsable',
        campo: 'destinoResponsableIds',
        tipo: 'text',
        // eslint-disable-next-line no-template-curly-in-string
        valor: '${idUsuario}'
      },
      {
        nombre: 'Tipo expediente',
        campo: 'claseMercadoPublico',
        tipo: 'multi',
        // eslint-disable-next-line no-template-curly-in-string
        opciones: {
          int: 'Interno',
          ext: 'Externo',
          numInt: 'Num. Interno',
          numOf: 'Num. Oficial'
        }
      },
      {
        nombre: 'Tipo',
        campo: 'tipo',
        tipo: 'text',
        valor: 'EXP'
      },
      {
        nombre: 'Estado',
        campo: 'estado',
        tipo: 'multi',
        opciones: {
          3: 'Borrador'
        }
      }
    ],
    filtrosHabilitados: [
      {
        nombre: 'Núm Exp.', campo: 'numero', tipo: 'texto', valor: []
      },
      {
        nombre: 'Núm Doc.', campo: 'numeroInt', tipo: 'texto', valor: []
      },
      {
        nombre: 'Alcance del expediente',
        campo: 'transportePuertoTipo', // es privado
        tipo: 'multi',
        valor: [],
        opciones: {
          [PRIVACITY.RESERVED]: 'Documento reservado',
          [PRIVACITY.CONFIDENTIAL]: 'Documento privado',
          [PRIVACITY.PUBLIC]: 'Documento público'
        }
      },
      {
        nombre: 'Tipo Expediente',
        campo: 'claseMercadoPublico', // tipo de expedient
        tipo: 'multi',
        valor: [],
        opciones: {
          numInt: 'Numeración interna',
          numOf: 'Numeración oficial',
          ext: 'Externo',
          int: 'Interno'
        }
      },
      {
        nombre: 'Acompaña físico',
        campo: 'transporteViaTransporteCodigoTransporte',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Acompaña físico',
          0: 'No Acompaña físico'
        }
      },
      {
        nombre: 'Tipo de destino',
        campo: 'destinoCodigoIds',
        tipo: 'multi',
        valor: [],
        opciones: {
          usuarios: 'Funcionarios',
          unidades: 'Unidades',
          oficinas: 'Oficinas',
          docDigital: 'DocDigital',
          ministerios: 'Ministerios',
          empresas: 'Empresas',
          personas: 'Personas'
        }
      },
      {
        nombre: 'Tipo de referencia',
        campo: 'codigosReferenciasTipos',
        tipo: 'multi',
        valor: [],
        opciones: {
          EXP: 'Expediente',
          SSD: 'Proceso SSD'
        }
      },
      {
        nombre: 'Fecha documento', campo: 'fechaEmision', tipo: 'fecha', valor: ''
      },
      {
        nombre: 'Nombre remitente', campo: 'emisorContactoNombre', tipo: 'texto', valor: []
      },
      {
        nombre: 'Cargo remitente', campo: 'emisorContactoCargo', tipo: 'texto', valor: []
      },
      {
        nombre: 'Correo remitente', campo: 'emisorContactoEmail', tipo: 'texto', valor: []
      },
      {
        nombre: 'Destino tipo correo', campo: 'destinoCorreoIds', tipo: 'texto', valor: []
      },
      { nombre: 'Derivado por', campo: 'codigosDerivacionUsuario', tipo: 'derivadoIds' },
      { nombre: 'Tipo institución', campo: 'compradorCodigo', tipo: 'opcionInst' },
      { nombre: 'Tipo Documento', campo: 'tiposDocumentos', tipo: 'opcionDoc' },
      { nombre: 'Destino tipo usuario', campo: 'destinoParticipanteIds', tipo: 'usuarioIds' },
      { nombre: 'Destino tipo grupo', campo: 'destinoParticipanteIds', tipo: 'grupoIds' },
      { nombre: 'Usuario creador', campo: 'solicitanteEmail', tipo: 'correos' },
      { nombre: 'Destino Institución Doc Digital', campo: 'destinoInstitucionCodigos', tipo: 'institutionsDD' },
      { nombre: 'Unidad del destino', campo: 'destinoListaCodigoUnidad', tipo: 'grupoDestino' }
    ]
  },
  pendientes: {
    filtrosFijos: [
      {
        // eslint-disable-next-line no-template-curly-in-string
        nombre: 'Rut emisor', campo: 'emisorRut', tipo: 'text', valor: '${iutEmpresa}'
      },
      {
        nombre: 'Responsable',
        campo: 'destinoResponsableIds',
        tipo: 'text',
        // eslint-disable-next-line no-template-curly-in-string
        valor: '${idUsuario}'
      },
      {
        nombre: 'Tipo',
        campo: 'tipo',
        tipo: 'text',
        valor: 'EXP'
      },
      {
        nombre: 'Tipo expediente',
        campo: 'claseMercadoPublico',
        tipo: 'multi',
        opciones: {
          int: 'Interno',
          ext: 'Externo',
          numInt: 'Num. Interno',
          numOf: 'Num. Oficial'
        }
      },
      {
        nombre: 'Estado',
        campo: 'estado',
        tipo: 'multi',
        opciones: {
          1: 'Creado'
        }
      }
    ],
    filtrosHabilitados: [
      {
        nombre: 'Persona remitente', campo: 'despachoContactoNombre', tipo: 'texto', valor: []
      },
      {
        nombre: 'Folio', campo: 'numero', tipo: 'texto', valor: []
      },
      {
        nombre: 'Fecha documento', campo: 'fechaEmision', tipo: 'fecha', valor: ''
      },
      {
        nombre: 'Núm Exp.', campo: 'numero', tipo: 'texto', valor: []
      },
      {
        nombre: 'Núm Doc.', campo: 'numeroInt', tipo: 'texto', valor: []
      },
      {
        nombre: 'Alcance del expediente',
        campo: 'transportePuertoTipo', // es privado
        tipo: 'multi',
        valor: [],
        opciones: {
          [PRIVACITY.RESERVED]: 'Documento reservado',
          [PRIVACITY.CONFIDENTIAL]: 'Documento privado',
          [PRIVACITY.PUBLIC]: 'Documento público'
        }
      },
      {
        nombre: 'Providencia',
        campo: 'destinatarios.providenciaId', // es privado
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Conocimiento',
          2: 'Gestión'
        }
      },
      {
        nombre: 'Requiere respuesta',
        campo: 'receptorTelefono', // es privado
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Si',
          0: 'No'
        }
      },
      {
        nombre: 'Tipo Expediente',
        campo: 'claseMercadoPublico', // tipo de expedient
        tipo: 'multi',
        valor: [],
        opciones: {
          numInt: 'Numeración interna',
          numOf: 'Numeración oficial',
          ext: 'Externo',
          int: 'Interno'
        }
      },
      {
        nombre: 'Acompaña físico',
        campo: 'transporteViaTransporteCodigoTransporte',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Acompaña físico',
          0: 'No Acompaña físico'
        }
      },
      {
        nombre: 'Tipo de destino',
        campo: 'destinoCodigoIds',
        tipo: 'multi',
        valor: [],
        opciones: {
          usuarios: 'Funcionarios',
          unidades: 'Unidades',
          oficinas: 'Oficinas',
          docDigital: 'DocDigital',
          ministerios: 'Ministerios',
          empresas: 'Empresas',
          personas: 'Personas'
        }
      },
      {
        nombre: 'Tipo de referencia',
        campo: 'codigosReferenciasTipos',
        tipo: 'multi',
        valor: [],
        opciones: {
          EXP: 'Expediente',
          SSD: 'Proceso SSD'
        }
      },
      {
        nombre: 'Nombre remitente', campo: 'emisorContactoNombre', tipo: 'texto', valor: []
      },
      {
        nombre: 'Cargo remitente', campo: 'emisorContactoCargo', tipo: 'texto', valor: []
      },
      {
        nombre: 'Correo remitente', campo: 'emisorContactoEmail', tipo: 'texto', valor: []
      },
      {
        nombre: 'Destino tipo correo', campo: 'destinoCorreoIds', tipo: 'texto', valor: []
      },
      { nombre: 'Derivado por', campo: 'codigosDerivacionUsuario', tipo: 'derivadoIds' },
      { nombre: 'Tipo Documento', campo: 'tiposDocumentos', tipo: 'opcionDoc' },
      { nombre: 'Tipo institución', campo: 'compradorCodigo', tipo: 'opcionInst' },
      { nombre: 'Destino tipo usuario', campo: 'destinoParticipanteIds', tipo: 'usuarioIds' },
      { nombre: 'Destino tipo grupo', campo: 'destinoParticipanteIds', tipo: 'grupoIds' },
      { nombre: 'Usuario creador', campo: 'solicitanteEmail', tipo: 'correos' },
      { nombre: 'Destino Institución Doc Digital', campo: 'destinoInstitucionCodigos', tipo: 'institutionsDD' },
      { nombre: 'Unidad del creador', campo: 'solicitanteGrupoId', tipo: 'grupoCreador' },
      { nombre: 'Unidad del destino', campo: 'destinoListaCodigoUnidad', tipo: 'grupoDestino' }
    ]
  },
  'pendientes-unidad': {
    filtrosFijos: [
      {
        // eslint-disable-next-line no-template-curly-in-string
        nombre: 'Rut emisor', campo: 'emisorRut', tipo: 'text', valor: '${iutEmpresa}'
      },
      {
        nombre: 'Responsable',
        campo: 'pendientesUnidad',
        tipo: 'text',
        // eslint-disable-next-line no-template-curly-in-string
        valor: '${idUsuario}'
      },
      {
        nombre: 'Tipo',
        campo: 'tipo',
        tipo: 'text',
        valor: 'EXP'
      },
      {
        nombre: 'Tipo expediente',
        campo: 'claseMercadoPublico',
        tipo: 'multi',
        opciones: {
          int: 'Interno',
          ext: 'Externo',
          numInt: 'Num. Interno',
          numOf: 'Num. Oficial'
        }
      },
      {
        nombre: 'Estado',
        campo: 'estado',
        tipo: 'multi',
        opciones: {
          1: 'Creado'
        }
      }
    ],
    filtrosHabilitados: [
      {
        nombre: 'Fecha documento', campo: 'fechaEmision', tipo: 'fecha', valor: ''
      },
      {
        nombre: 'Núm Exp.', campo: 'numero', tipo: 'texto', valor: []
      },
      {
        nombre: 'Núm Doc.', campo: 'numeroInt', tipo: 'texto', valor: []
      },
      {
        nombre: 'Alcance del expediente',
        campo: 'transportePuertoTipo', // es privado
        tipo: 'multi',
        valor: [],
        opciones: {
          [PRIVACITY.RESERVED]: 'Documento reservado',
          [PRIVACITY.CONFIDENTIAL]: 'Documento privado',
          [PRIVACITY.PUBLIC]: 'Documento público'
        }
      },
      {
        nombre: 'Tipo Expediente',
        campo: 'claseMercadoPublico', // tipo de expedient
        tipo: 'multi',
        valor: [],
        opciones: {
          numInt: 'Numeración interna',
          numOf: 'Numeración oficial',
          ext: 'Externo',
          int: 'Interno'
        }
      },
      {
        nombre: 'Acompaña físico',
        campo: 'transporteViaTransporteCodigoTransporte',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Acompaña físico',
          0: 'No Acompaña físico'
        }
      },
      {
        nombre: 'Tipo de destino',
        campo: 'destinoCodigoIds',
        tipo: 'multi',
        valor: [],
        opciones: {
          usuarios: 'Funcionarios',
          unidades: 'Unidades',
          oficinas: 'Oficinas',
          docDigital: 'DocDigital',
          ministerios: 'Ministerios',
          empresas: 'Empresas',
          personas: 'Personas'
        }
      },
      {
        nombre: 'Tipo de referencia',
        campo: 'codigosReferenciasTipos',
        tipo: 'multi',
        valor: [],
        opciones: {
          EXP: 'Expediente',
          SSD: 'Proceso SSD'
        }
      },
      {
        nombre: 'Nombre remitente', campo: 'emisorContactoNombre', tipo: 'texto', valor: []
      },
      {
        nombre: 'Cargo remitente', campo: 'emisorContactoCargo', tipo: 'texto', valor: []
      },
      {
        nombre: 'Correo remitente', campo: 'emisorContactoEmail', tipo: 'texto', valor: []
      },
      {
        nombre: 'Destino tipo correo', campo: 'destinoCorreoIds', tipo: 'texto', valor: []
      },
      { nombre: 'Derivado por', campo: 'codigosDerivacionUsuario', tipo: 'derivadoIds' },
      { nombre: 'Tipo Documento', campo: 'tiposDocumentos', tipo: 'opcionDoc' },
      { nombre: 'Tipo institución', campo: 'compradorCodigo', tipo: 'opcionInst' },
      { nombre: 'Destino tipo usuario', campo: 'destinoParticipanteIds', tipo: 'usuarioIds' },
      { nombre: 'Destino tipo grupo', campo: 'destinoParticipanteIds', tipo: 'grupoIds' },
      { nombre: 'Usuario creador', campo: 'solicitanteEmail', tipo: 'correos' },
      { nombre: 'Destino Institución Doc Digital', campo: 'destinoInstitucionCodigos', tipo: 'institutionsDD' },
      { nombre: 'Unidad del creador', campo: 'solicitanteGrupoId', tipo: 'grupoCreador' },
      { nombre: 'Unidad del destino', campo: 'destinoListaCodigoUnidad', tipo: 'grupoDestino' },
      {
        nombre: 'Providencia',
        campo: 'destinatarios.providenciaId', // es privado
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Conocimiento',
          2: 'Gestión'
        }
      },
      {
        nombre: 'Requiere respuesta',
        campo: 'receptorTelefono', // es privado
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Si',
          0: 'No'
        }
      },
    ]
  },
  ingresados: {
    filtrosFijos: [
      {
        // eslint-disable-next-line no-template-curly-in-string
        nombre: 'Rut emisor', campo: 'emisorRut', tipo: 'text', valor: '${iutEmpresa}'
      },
      {
        nombre: 'Tipo',
        campo: 'tipo',
        tipo: 'text',
        valor: 'EXP'
      },
      {
        nombre: 'Es Documento Madre',
        campo: 'estadoCodigoEstadoComprador',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Si',
          0: 'No'
        }
      },
      {
        nombre: 'Tipo expediente',
        campo: 'claseMercadoPublico',
        tipo: 'multi',
        opciones: {
          int: 'Interno',
          ext: 'Externo',
          numInt: 'Num. Interno',
          numOf: 'Num. Oficial'
        }
      },
      {
        nombre: 'Estado',
        campo: 'estado',
        tipo: 'multi',
        opciones: {
          2: 'Ingresado'
        }
      }
    ],
    filtrosHabilitados: [
      {
        nombre: 'Fecha documento', campo: 'fechaEmision', tipo: 'fecha', valor: ''
      },
      {
        nombre: 'Es Documento Madre',
        campo: 'estadoCodigoEstadoComprador',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Si',
          0: 'No'
        }
      },
      {
        nombre: 'Persona remitente', campo: 'despachoContactoNombre', tipo: 'texto', valor: []
      },
      {
        nombre: 'Folio', campo: 'numero', tipo: 'texto', valor: []
      },
      {
        nombre: 'Núm Exp.', campo: 'numero', tipo: 'texto', valor: []
      },
      {
        nombre: 'Núm Doc.', campo: 'numeroInt', tipo: 'texto', valor: []
      },
      {
        nombre: 'Es privado',
        campo: 'transportePuertoTipo', // es privado
        tipo: 'multi',
        valor: [],
        opciones: {
          [PRIVACITY.CONFIDENTIAL]: 'Documento privado',
          [PRIVACITY.PUBLIC]: 'Documento público'
        }
      },
      {
        nombre: 'Tipo Expediente',
        campo: 'claseMercadoPublico', // tipo de expedient
        tipo: 'multi',
        valor: [],
        opciones: {
          numInt: 'Numeración interna',
          numOf: 'Numeración oficial',
          ext: 'Externo',
          int: 'Interno'
        }
      },
      {
        nombre: 'Acompaña físico',
        campo: 'transporteViaTransporteCodigoTransporte',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Acompaña físico',
          0: 'No Acompaña físico'
        }
      },
      {
        nombre: 'Tipo de destino',
        campo: 'destinoCodigoIds',
        tipo: 'multi',
        valor: [],
        opciones: {
          usuarios: 'Funcionarios',
          unidades: 'Unidades',
          oficinas: 'Oficinas',
          docDigital: 'DocDigital',
          ministerios: 'Ministerios',
          empresas: 'Empresas',
          personas: 'Personas'
        }
      },
      {
        nombre: 'Tipo de referencia',
        campo: 'codigosReferenciasTipos',
        tipo: 'multi',
        valor: [],
        opciones: {
          EXP: 'Expediente',
          SSD: 'Proceso SSD'
        }
      },
      {
        nombre: 'Nombre remitente', campo: 'emisorContactoNombre', tipo: 'texto', valor: []
      },
      {
        nombre: 'Cargo remitente', campo: 'emisorContactoCargo', tipo: 'texto', valor: []
      },
      {
        nombre: 'Correo remitente', campo: 'emisorContactoEmail', tipo: 'texto', valor: []
      },
      {
        nombre: 'Destino tipo correo', campo: 'destinoCorreoIds', tipo: 'texto', valor: []
      },
      { nombre: 'Derivado por', campo: 'codigosDerivacionUsuario', tipo: 'derivadoIds' },
      { nombre: 'Tipo Documento', campo: 'tiposDocumentos', tipo: 'opcionDoc' },
      { nombre: 'Tipo institución', campo: 'compradorCodigo', tipo: 'opcionInst' },
      { nombre: 'Destino tipo usuario', campo: 'destinoParticipanteIds', tipo: 'usuarioIds' },
      { nombre: 'Destino tipo grupo', campo: 'destinoParticipanteIds', tipo: 'grupoIds' },
      { nombre: 'Usuario creador', campo: 'solicitanteEmail', tipo: 'correos' },
      { nombre: 'Destino Institución Doc Digital', campo: 'destinoInstitucionCodigos', tipo: 'institutionsDD' },
      { nombre: 'Unidad del creador', campo: 'solicitanteGrupoId', tipo: 'grupoCreador' },
      { nombre: 'Unidad del destino', campo: 'destinoListaCodigoUnidad', tipo: 'grupoDestino' }
    ]
  },
  completitudDatos: {
    filtrosFijos: [
      {
        // eslint-disable-next-line no-template-curly-in-string
        nombre: 'Rut emisor', campo: 'emisorRut', tipo: 'text', valor: '${iutEmpresa}'
      },
      {
        nombre: 'Documento esta completo', campo: 'solicitanteCodigo', tipo: 'text', valor: 'null'
      },
      {
        nombre: 'Tipo',
        campo: 'tipo',
        tipo: 'text',
        valor: 'EXP'
      },
      {
        nombre: 'Tipo expediente',
        campo: 'claseMercadoPublico',
        tipo: 'multi',
        opciones: {
          int: 'Interno',
          ext: 'Externo',
          numInt: 'Num. Interno',
          numOf: 'Num. Oficial'
        }
      },
      {
        nombre: 'Estado',
        campo: 'estado',
        tipo: 'multi',
        opciones: {
          1: 'Creado',
          2: 'Ingresado',
          9: 'Finalizado'
        }
      }
    ],
    filtrosHabilitados: [
      {
        nombre: 'Persona remitente', campo: 'despachoContactoNombre', tipo: 'texto', valor: []
      },
      {
        nombre: 'Folio', campo: 'numero', tipo: 'texto', valor: []
      },
      {
        nombre: 'Fecha documento', campo: 'fechaEmision', tipo: 'fecha', valor: ''
      },
      {
        nombre: 'Núm Exp.', campo: 'numero', tipo: 'texto', valor: []
      },
      {
        nombre: 'Es Documento Madre',
        campo: 'estadoCodigoEstadoComprador',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Si',
          0: 'No'
        }
      },
      {
        nombre: 'Núm Doc.', campo: 'numeroInt', tipo: 'texto', valor: []
      },
      {
        nombre: 'Estado',
        campo: 'estado',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Creado',
          2: 'Ingresado'
        }
      },
      {
        nombre: 'Es privado',
        campo: 'transportePuertoTipo', // es privado
        tipo: 'multi',
        valor: [],
        opciones: {
          [PRIVACITY.CONFIDENTIAL]: 'Documento privado',
          [PRIVACITY.PUBLIC]: 'Documento público'
        }
      },
      {
        nombre: 'Tipo Expediente',
        campo: 'claseMercadoPublico', // tipo de expedient
        tipo: 'multi',
        valor: [],
        opciones: {
          numInt: 'Numeración interna',
          numOf: 'Numeración oficial',
          ext: 'Externo',
          int: 'Interno'
        }
      },
      {
        nombre: 'Acompaña físico',
        campo: 'transporteViaTransporteCodigoTransporte',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Acompaña físico',
          0: 'No Acompaña físico'
        }
      },
      {
        nombre: 'Tipo de destino',
        campo: 'destinoCodigoIds',
        tipo: 'multi',
        valor: [],
        opciones: {
          usuarios: 'Funcionarios',
          unidades: 'Unidades',
          oficinas: 'Oficinas',
          docDigital: 'DocDigital',
          ministerios: 'Ministerios',
          empresas: 'Empresas',
          personas: 'Personas'
        }
      },
      {
        nombre: 'Tipo de referencia',
        campo: 'codigosReferenciasTipos',
        tipo: 'multi',
        valor: [],
        opciones: {
          EXP: 'Expediente',
          SSD: 'Proceso SSD'
        }
      },
      {
        nombre: 'Nombre remitente', campo: 'emisorContactoNombre', tipo: 'texto', valor: []
      },
      {
        nombre: 'Cargo remitente', campo: 'emisorContactoCargo', tipo: 'texto', valor: []
      },
      {
        nombre: 'Correo remitente', campo: 'emisorContactoEmail', tipo: 'texto', valor: []
      },
      {
        nombre: 'Destino tipo correo', campo: 'destinoCorreoIds', tipo: 'texto', valor: []
      },
      { nombre: 'Derivado por', campo: 'codigosDerivacionUsuario', tipo: 'derivadoIds' },
      { nombre: 'Tipo Documento', campo: 'tiposDocumentos', tipo: 'opcionDoc' },
      { nombre: 'Tipo institución', campo: 'compradorCodigo', tipo: 'opcionInst' },
      { nombre: 'Destino tipo usuario', campo: 'destinoParticipanteIds', tipo: 'usuarioIds' },
      { nombre: 'Destino tipo grupo', campo: 'destinoParticipanteIds', tipo: 'grupoIds' },
      { nombre: 'Usuario creador', campo: 'solicitanteEmail', tipo: 'correos' },
      { nombre: 'Destino Institución Doc Digital', campo: 'destinoInstitucionCodigos', tipo: 'institutionsDD' },
      { nombre: 'Unidad del creador', campo: 'solicitanteGrupoId', tipo: 'grupoCreador' },
      { nombre: 'Unidad del destino', campo: 'destinoListaCodigoUnidad', tipo: 'grupoDestino' }
    ]
  },
  tramitados: {
    filtrosFijos: [
      {
        // eslint-disable-next-line no-template-curly-in-string
        nombre: 'Rut emisor', campo: 'emisorRut', tipo: 'text', valor: '${iutEmpresa}'
      },
      {
        nombre: 'Responsable',
        campo: 'solicitanteDocumentoId',
        tipo: 'text',
        // eslint-disable-next-line no-template-curly-in-string
        valor: '${idUsuario}'
      },
      {
        nombre: 'Tipo',
        campo: 'tipo',
        tipo: 'text',
        valor: 'EXP'
      },
      {
        nombre: 'Tipo expediente',
        campo: 'claseMercadoPublico',
        tipo: 'multi',
        opciones: {
          numInt: 'Num. Interno',
          numOf: 'Num. Oficial'
        }
      },
      {
        nombre: 'Estado',
        campo: 'estado',
        tipo: 'multi',
        opciones: {
          10: 'Tramitado',
          5: 'Rechazado',
          12: 'Aprobado',
          15: 'Numerado',
          70: 'En contraloría',
          100: 'Archivado'
        }
      }
    ],
    filtrosHabilitados: [
      {
        nombre: 'Fecha documento', campo: 'fechaEmision', tipo: 'fecha', valor: ''
      },
      {
        nombre: 'Núm Exp.', campo: 'numero', tipo: 'texto', valor: []
      },
      {
        nombre: 'Núm Doc.', campo: 'numeroInt', tipo: 'texto', valor: []
      },
      {
        nombre: 'Estado',
        campo: 'estado',
        tipo: 'multi',
        opciones: {
          10: 'Tramitado',
          5: 'Rechazado',
          12: 'Aprobado',
          15: 'Numerado',
          70: 'En contraloría',
          100: 'Archivado'
        }
      },
      {
        nombre: 'Alcance del expediente',
        campo: 'transportePuertoTipo', // es privado
        tipo: 'multi',
        valor: [],
        opciones: {
          [PRIVACITY.RESERVED]: 'Documento reservado',
          [PRIVACITY.CONFIDENTIAL]: 'Documento privado',
          [PRIVACITY.PUBLIC]: 'Documento público'
        }
      },
      {
        nombre: 'Tipo Expediente',
        campo: 'claseMercadoPublico', // tipo de expedient
        tipo: 'multi',
        valor: [],
        opciones: {
          numInt: 'Numeración interna',
          numOf: 'Numeración oficial',
          ext: 'Externo',
          int: 'Interno'
        }
      },
      {
        nombre: 'Acompaña físico',
        campo: 'transporteViaTransporteCodigoTransporte',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Acompaña físico',
          0: 'No Acompaña físico'
        }
      },
      {
        nombre: 'Tipo de destino',
        campo: 'destinoCodigoIds',
        tipo: 'multi',
        valor: [],
        opciones: {
          usuarios: 'Funcionarios',
          unidades: 'Unidades',
          oficinas: 'Oficinas',
          docDigital: 'DocDigital',
          ministerios: 'Ministerios',
          empresas: 'Empresas',
          personas: 'Personas'
        }
      },
      {
        nombre: 'Tipo de referencia',
        campo: 'codigosReferenciasTipos',
        tipo: 'multi',
        valor: [],
        opciones: {
          EXP: 'Expediente',
          SSD: 'Proceso SSD'
        }
      },
      {
        nombre: 'Nombre remitente', campo: 'emisorContactoNombre', tipo: 'texto', valor: []
      },
      {
        nombre: 'Cargo remitente', campo: 'emisorContactoCargo', tipo: 'texto', valor: []
      },
      {
        nombre: 'Correo remitente', campo: 'emisorContactoEmail', tipo: 'texto', valor: []
      },
      {
        nombre: 'Destino tipo correo', campo: 'destinoCorreoIds', tipo: 'texto', valor: []
      },
      { nombre: 'Derivado por', campo: 'codigosDerivacionUsuario', tipo: 'derivadoIds' },
      { nombre: 'Tipo Documento', campo: 'tiposDocumentos', tipo: 'opcionDoc' },
      { nombre: 'Tipo institución', campo: 'compradorCodigo', tipo: 'opcionInst' },
      { nombre: 'Destino tipo usuario', campo: 'destinoParticipanteIds', tipo: 'usuarioIds' },
      { nombre: 'Destino tipo grupo', campo: 'destinoParticipanteIds', tipo: 'grupoIds' },
      { nombre: 'Unidad del destino', campo: 'destinoListaCodigoUnidad', tipo: 'grupoDestino' },
      { nombre: 'Destino Institución Doc Digital', campo: 'destinoInstitucionCodigos', tipo: 'institutionsDD' },
    ]
  },
  finalizados: {
    filtrosFijos: [
      {
        // eslint-disable-next-line no-template-curly-in-string
        nombre: 'Rut emisor', campo: 'emisorRut', tipo: 'text', valor: '${iutEmpresa}'
      },
      {
        nombre: 'Tipo',
        campo: 'tipo',
        tipo: 'text',
        valor: 'EXP'
      },
      {
        nombre: 'Tipo expediente',
        campo: 'claseMercadoPublico',
        tipo: 'multi',
        opciones: {
          int: 'Interno',
          ext: 'Externo',
          numInt: 'Num. Interno',
          numOf: 'Num. Oficial'
        }
      },
      {
        nombre: 'Estado',
        campo: 'estado',
        tipo: 'multi',
        opciones: {
          9: 'Finalizado'
        }
      },
      {
        nombre: 'Finalizador',
        campo: 'destinoFinalizadoIds',
        tipo: 'text',
        // eslint-disable-next-line no-template-curly-in-string
        valor: '${idUsuario}'
      }
    ],
    filtrosHabilitados: [
      {
        nombre: 'Fecha documento', campo: 'fechaEmision', tipo: 'fecha', valor: ''
      },
      {
        nombre: 'Núm Exp.', campo: 'numero', tipo: 'texto', valor: []
      },
      {
        nombre: 'Núm Doc.', campo: 'numeroInt', tipo: 'texto', valor: []
      },
      {
        nombre: 'Alcance del expediente',
        campo: 'transportePuertoTipo', // es privado
        tipo: 'multi',
        valor: [],
        opciones: {
          [PRIVACITY.RESERVED]: 'Documento reservado',
          [PRIVACITY.CONFIDENTIAL]: 'Documento privado',
          [PRIVACITY.PUBLIC]: 'Documento público'
        }
      },
      {
        nombre: 'Tipo Expediente',
        campo: 'claseMercadoPublico', // tipo de expedient
        tipo: 'multi',
        valor: [],
        opciones: {
          numInt: 'Numeración interna',
          numOf: 'Numeración oficial',
          ext: 'Externo',
          int: 'Interno'
        }
      },
      {
        nombre: 'Acompaña físico',
        campo: 'transporteViaTransporteCodigoTransporte',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Acompaña físico',
          0: 'No Acompaña físico'
        }
      },
      {
        nombre: 'Tipo de destino',
        campo: 'destinoCodigoIds',
        tipo: 'multi',
        valor: [],
        opciones: {
          usuarios: 'Funcionarios',
          unidades: 'Unidades',
          oficinas: 'Oficinas',
          docDigital: 'DocDigital',
          ministerios: 'Ministerios',
          empresas: 'Empresas',
          personas: 'Personas'
        }
      },
      {
        nombre: 'Tipo de referencia',
        campo: 'codigosReferenciasTipos',
        tipo: 'multi',
        valor: [],
        opciones: {
          EXP: 'Expediente',
          SSD: 'Proceso SSD'
        }
      },
      {
        nombre: 'Nombre remitente', campo: 'emisorContactoNombre', tipo: 'texto', valor: []
      },
      {
        nombre: 'Cargo remitente', campo: 'emisorContactoCargo', tipo: 'texto', valor: []
      },
      {
        nombre: 'Correo remitente', campo: 'emisorContactoEmail', tipo: 'texto', valor: []
      },
      {
        nombre: 'Destino tipo correo', campo: 'destinoCorreoIds', tipo: 'texto', valor: []
      },
      { nombre: 'Derivado por', campo: 'codigosDerivacionUsuario', tipo: 'derivadoIds' },
      { nombre: 'Tipo Documento', campo: 'tiposDocumentos', tipo: 'opcionDoc' },
      { nombre: 'Tipo institución', campo: 'compradorCodigo', tipo: 'opcionInst' },
      { nombre: 'Destino tipo usuario', campo: 'destinoParticipanteIds', tipo: 'usuarioIds' },
      { nombre: 'Destino tipo grupo', campo: 'destinoParticipanteIds', tipo: 'grupoIds' },
      { nombre: 'Unidad del destino', campo: 'destinoListaCodigoUnidad', tipo: 'grupoDestino' },
      { nombre: 'Destino Institución Doc Digital', campo: 'destinoInstitucionCodigos', tipo: 'institutionsDD' },
    ]
  },
  general: {
    filtrosFijos: [
      {
        nombre: 'Rut emisor',
        campo: 'emisorRut',
        tipo: 'text',
        // eslint-disable-next-line no-template-curly-in-string
        valor: '${iutEmpresa}'
      },
      {
        nombre: 'Tipo',
        campo: 'tipo',
        tipo: 'text',
        valor: 'EXP'
      },
      {
        nombre: 'Documentos generales$',
        campo: 'general',
        tipo: 'text',
        valor: '0'
      },
      {
        nombre: 'Estado',
        campo: 'estado',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Creado',
          2: 'Ingresado',
          8: 'Anulado',
          9: 'Finalizado',
          6: 'En flujo',
          5: 'Rechazado',
          10: 'Tramitado',
          12: 'Aprobado',
          100: 'Archivado'
        }
      }
    ],
    filtrosHabilitados: [
      {
        nombre: 'Núm Exp.', campo: 'numero', tipo: 'texto', valor: []
      },
      {
        nombre: 'Núm Doc.', campo: 'numeroInt', tipo: 'texto', valor: []
      },
      {
        nombre: 'Es Documento Madre',
        campo: 'estadoCodigoEstadoComprador',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Si',
          0: 'No'
        }
      },
      {
        nombre: 'Estado',
        campo: 'estado',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Creado',
          2: 'Ingresado',
          8: 'Anulado',
          9: 'Finalizado',
          6: 'En flujo',
          5: 'Rechazado',
          10: 'Tramitado',
          12: 'Aprobado',
          100: 'Archivado'
        }
      },
      /*
      {
        nombre: 'Es privado',
        campo: 'transportePuertoTipo', // es privado
        tipo: 'multi',
        valor: [],
        opciones: {
            [PRIVACITY.CONFIDENTIAL]: 'Documento privado',
            [PRIVACITY.PUBLIC]: 'Documento público'
        }
      },
      */
      {
        nombre: 'Tipo Expediente',
        campo: 'claseMercadoPublico', // tipo de expedient
        tipo: 'multi',
        valor: [],
        opciones: {
          numInt: 'Numeración interna',
          numOf: 'Numeración oficial',
          ext: 'Externo',
          int: 'Interno'
        }
      },
      {
        nombre: 'Acompaña físico',
        campo: 'transporteViaTransporteCodigoTransporte',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Acompaña físico',
          0: 'No Acompaña físico'
        }
      },
      {
        nombre: 'Tipo de destino',
        campo: 'destinoCodigoIds',
        tipo: 'multi',
        valor: [],
        opciones: {
          usuarios: 'Funcionarios',
          unidades: 'Unidades',
          oficinas: 'Oficinas',
          docDigital: 'DocDigital',
          ministerios: 'Ministerios',
          empresas: 'Empresas',
          personas: 'Personas'
        }
      },
      {
        nombre: 'Tipo de referencia',
        campo: 'codigosReferenciasTipos',
        tipo: 'multi',
        valor: [],
        opciones: {
          EXP: 'Expediente',
          SSD: 'Proceso SSD'
        }
      },
      {
        nombre: 'Fecha documento', campo: 'fechaEmision', tipo: 'fecha', valor: ''
      },
      {
        nombre: 'Nombre remitente', campo: 'emisorContactoNombre', tipo: 'texto', valor: []
      },
      {
        nombre: 'Persona remitente', campo: 'despachoContactoNombre', tipo: 'texto', valor: []
      },
      {
        nombre: 'Folio', campo: 'numero', tipo: 'texto', valor: []
      },
      {
        nombre: 'Cargo remitente', campo: 'emisorContactoCargo', tipo: 'texto', valor: []
      },
      {
        nombre: 'Correo remitente', campo: 'emisorContactoEmail', tipo: 'texto', valor: []
      },
      {
        nombre: 'Destino tipo correo', campo: 'destinoCorreoIds', tipo: 'texto', valor: []
      },
      { nombre: 'Derivado por', campo: 'codigosDerivacionUsuario', tipo: 'derivadoIds' },
      { nombre: 'Tipo institución', campo: 'compradorCodigo', tipo: 'opcionInst' },
      { nombre: 'Tipo Documento', campo: 'tiposDocumentos', tipo: 'opcionDoc' },
      { nombre: 'Destino tipo usuario', campo: 'destinoParticipanteIds', tipo: 'usuarioIds' },
      { nombre: 'Destino tipo grupo', campo: 'destinoParticipanteIds', tipo: 'grupoIds' },
      { nombre: 'Usuario creador', campo: 'solicitanteEmail', tipo: 'correos' },
      { nombre: 'Destino Institución Doc Digital', campo: 'destinoInstitucionCodigos', tipo: 'institutionsDD' },
      { nombre: 'Unidad del creador', campo: 'solicitanteGrupoId', tipo: 'grupoCreador' },
      { nombre: 'Unidad del destino', campo: 'destinoListaCodigoUnidad', tipo: 'grupoDestino' },
      { nombre: 'Oficina en flujo', campo: 'aprParticipante', tipo: 'oficinaIds' }
    ]
  },
  docDigital: {
    filtrosFijos: [
      {
        nombre: 'Rut emisor',
        campo: 'emisorRut',
        tipo: 'text',
        // eslint-disable-next-line no-template-curly-in-string
        valor: '${iutEmpresa}'
      },
      {
        nombre: 'Tipo',
        campo: 'tipo',
        tipo: 'text',
        valor: 'EXP'
      },
      {
        nombre: 'Tipo de destino',
        campo: 'destinoCodigoIds',
        tipo: 'multi',
        valor: [],
        opciones: {
          docDigital: 'DocDigital'
        }
      },
      {
        nombre: 'Documento público',
        campo: 'transportePuertoTipo',
        tipo: 'text',
        valor: '0'
      },
      {
        nombre: 'Tipo expediente',
        campo: 'claseMercadoPublico',
        tipo: 'multi',
        // eslint-disable-next-line no-template-curly-in-string
        opciones: {
          int: 'Interno',
          ext: 'Externo',
          numInt: 'Num. Interno',
          numOf: 'Num. Oficial'
        }
      },
      {
        nombre: 'Estado',
        campo: 'estado',
        tipo: 'multi',
        opciones: {
          1: 'Creado',
          8: 'Anulado',
          9: 'Finalizado',
          6: 'En flujo',
          5: 'Rechazado',
          12: 'Aprobado',
          100: 'Archivado'
        }
      }
    ],
    filtrosHabilitados: [
      {
        nombre: 'Núm Exp.', campo: 'numero', tipo: 'texto', valor: []
      },
      {
        nombre: 'Núm Doc.', campo: 'numeroInt', tipo: 'texto', valor: []
      },
      {
        nombre: 'Estado',
        campo: 'estado',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Creado',
          8: 'Anulado',
          9: 'Finalizado',
          6: 'En flujo',
          5: 'Rechazado',
          12: 'Aprobado',
          100: 'Archivado'
        }
      },
      /*
      {
        nombre: 'Es privado',
        campo: 'transportePuertoTipo', // es privado
        tipo: 'multi',
        valor: [],
        opciones: {
            [PRIVACITY.CONFIDENTIAL]: 'Documento privado',
            [PRIVACITY.PUBLIC]: 'Documento público'
        }
      },
      */
      {
        nombre: 'Tipo Expediente',
        campo: 'claseMercadoPublico', // tipo de expedient
        tipo: 'multi',
        valor: [],
        opciones: {
          ext: 'Externo'
        }
      },
      {
        nombre: 'Acompaña físico',
        campo: 'transporteViaTransporteCodigoTransporte',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Acompaña físico',
          0: 'No Acompaña físico'
        }
      },
      {
        nombre: 'Tipo de referencia',
        campo: 'codigosReferenciasTipos',
        tipo: 'multi',
        valor: [],
        opciones: {
          EXP: 'Expediente',
          SSD: 'Proceso SSD'
        }
      },
      {
        nombre: 'Fecha documento', campo: 'fechaEmision', tipo: 'fecha', valor: ''
      },
      {
        nombre: 'Nombre remitente', campo: 'emisorContactoNombre', tipo: 'texto', valor: []
      },
      {
        nombre: 'Cargo remitente', campo: 'emisorContactoCargo', tipo: 'texto', valor: []
      },
      {
        nombre: 'Correo remitente', campo: 'emisorContactoEmail', tipo: 'texto', valor: []
      },
      {
        nombre: 'Observación / Materia', campo: 'textoObservaciones', tipo: 'texto', valor: []
      },
      { nombre: 'Derivado por', campo: 'codigosDerivacionUsuario', tipo: 'derivadoIds' },
      { nombre: 'Tipo institución', campo: 'compradorCodigo', tipo: 'opcionInst' },
      { nombre: 'Tipo Documento', campo: 'tiposDocumentos', tipo: 'opcionDoc' },
      { nombre: 'Usuario creador', campo: 'solicitanteEmail', tipo: 'correos' },
      { nombre: 'Destino Institución Doc Digital', campo: 'destinoInstitucionCodigos', tipo: 'institutionsDD' },
      { nombre: 'Unidad del creador', campo: 'solicitanteGrupoId', tipo: 'grupoCreador' }
    ]
  },
  compartido: {
    filtrosFijos: [
      {
        // eslint-disable-next-line no-template-curly-in-string
        nombre: 'Rut emisor', campo: 'emisorRut', tipo: 'text', valor: '${iutEmpresa}'
      },
      {
        nombre: 'Tipo',
        campo: 'tipo',
        tipo: 'text',
        valor: 'EXP'
      },
      {
        nombre: 'Tipo expediente',
        campo: 'claseMercadoPublico',
        tipo: 'multi',
        opciones: {
          int: 'Interno',
          ext: 'Externo',
          numInt: 'Num. Interno',
          numOf: 'Num. Oficial'
        }
      },
      {
        nombre: 'Estado',
        campo: 'estado',
        tipo: 'multi',
        opciones: {
          1: 'Creado'
        }
      }
    ],
    filtrosHabilitados: []
  },
  generalSoporte: {
    filtrosFijos: [
      {
        nombre: 'Rut emisor',
        campo: 'emisorRut',
        tipo: 'text',
        // eslint-disable-next-line no-template-curly-in-string
        valor: '${iutEmpresa}'
      },
      {
        nombre: 'Tipo',
        campo: 'tipo',
        tipo: 'text',
        valor: 'EXP'
      }
    ],
    filtrosHabilitados: [
      {
        nombre: 'Persona remitente', campo: 'despachoContactoNombre', tipo: 'texto', valor: []
      },
      {
        nombre: 'Folio', campo: 'numero', tipo: 'texto', valor: []
      },
      {
        nombre: 'Núm Exp.', campo: 'numero', tipo: 'texto', valor: []
      },
      {
        nombre: 'Núm Doc.', campo: 'numeroInt', tipo: 'texto', valor: []
      },
      {
        nombre: 'Es Documento Madre',
        campo: 'estadoCodigoEstadoComprador',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Si',
          0: 'No'
        }
      },
      {
        nombre: 'Estado',
        campo: 'estado',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Creado',
          3: 'Borrador',
          2: 'Ingresado',
          8: 'Anulado',
          9: 'Finalizado',
          6: 'En flujo',
          5: 'Rechazado',
          10: 'Tramitado',
          12: 'Aprobado',
          100: 'Archivado',
          101: 'Descartado'
        }
      },
      /*
      {
        nombre: 'Es privado',
        campo: 'transportePuertoTipo', // es privado
        tipo: 'multi',
        valor: [],
        opciones: {
            [PRIVACITY.CONFIDENTIAL]: 'Documento privado',
            [PRIVACITY.PUBLIC]: 'Documento público'
        }
      },
      */
      {
        nombre: 'Tipo Expediente',
        campo: 'claseMercadoPublico', // tipo de expedient
        tipo: 'multi',
        valor: [],
        opciones: {
          numInt: 'Numeración interna',
          numOf: 'Numeración oficial',
          ext: 'Externo',
          int: 'Interno'
        }
      },
      {
        nombre: 'Acompaña físico',
        campo: 'transporteViaTransporteCodigoTransporte',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Acompaña físico',
          0: 'No Acompaña físico'
        }
      },
      {
        nombre: 'Tipo de destino',
        campo: 'destinoCodigoIds',
        tipo: 'multi',
        valor: [],
        opciones: {
          usuarios: 'Funcionarios',
          unidades: 'Unidades',
          oficinas: 'Oficinas',
          docDigital: 'DocDigital',
          ministerios: 'Ministerios',
          empresas: 'Empresas',
          personas: 'Personas'
        }
      },
      {
        nombre: 'Tipo de referencia',
        campo: 'codigosReferenciasTipos',
        tipo: 'multi',
        valor: [],
        opciones: {
          EXP: 'Expediente',
          SSD: 'Proceso SSD'
        }
      },
      {
        nombre: 'Nº Contrato SAFI', campo: 'transportePuertoCodigo', tipo: 'texto', valor: []
      },
      {
        nombre: 'Fecha documento', campo: 'fechaEmision', tipo: 'fecha', valor: ''
      },
      {
        nombre: 'Nombre remitente', campo: 'emisorContactoNombre', tipo: 'texto', valor: []
      },
      {
        nombre: 'Cargo remitente', campo: 'emisorContactoCargo', tipo: 'texto', valor: []
      },
      {
        nombre: 'Correo remitente', campo: 'emisorContactoEmail', tipo: 'texto', valor: []
      },
      {
        nombre: 'Destino tipo correo', campo: 'destinoCorreoIds', tipo: 'texto', valor: []
      },
      { nombre: 'Derivado por', campo: 'codigosDerivacionUsuario', tipo: 'derivadoIds' },
      { nombre: 'Tipo institución', campo: 'compradorCodigo', tipo: 'opcionInst' },
      { nombre: 'Tipo Documento', campo: 'tiposDocumentos', tipo: 'opcionDoc' },
      { nombre: 'Destino tipo usuario', campo: 'destinoParticipanteIds', tipo: 'usuarioIds' },
      { nombre: 'Destino tipo grupo', campo: 'destinoParticipanteIds', tipo: 'grupoIds' },
      { nombre: 'Usuario creador', campo: 'solicitanteEmail', tipo: 'correos' },
      { nombre: 'Destino Institución Doc Digital', campo: 'destinoInstitucionCodigos', tipo: 'institutionsDD' },
      { nombre: 'Unidad del creador', campo: 'solicitanteGrupoId', tipo: 'grupoCreador' },
      { nombre: 'Unidad del destino', campo: 'destinoListaCodigoUnidad', tipo: 'grupoDestino' },
      { nombre: 'Oficina en flujo', campo: 'aprParticipante', tipo: 'oficinaIds' }
    ]
  },
  files: {
    filtrosFijos: [
      {
        nombre: 'Rut emisor',
        campo: 'emisorRut',
        tipo: 'text',
        // eslint-disable-next-line no-template-curly-in-string
        valor: '${iutEmpresa}'
      },
      {
        nombre: 'Tipo',
        campo: 'tipo',
        tipo: 'text',
        valor: 'EXP'
      },
      {
        nombre: 'Documentos generales$',
        campo: 'general',
        tipo: 'text',
        valor: '0'
      },
    ],
    filtrosHabilitados: [
      {
        nombre: 'Persona remitente', campo: 'despachoContactoNombre', tipo: 'texto', valor: []
      },
      {
        nombre: 'Folio', campo: 'numero', tipo: 'texto', valor: []
      },
      {
        nombre: 'Núm Exp.', campo: 'numero', tipo: 'texto', valor: []
      },
      {
        nombre: 'Núm Doc.', campo: 'numeroInt', tipo: 'texto', valor: []
      },
      {
        nombre: 'Es Documento Madre',
        campo: 'estadoCodigoEstadoComprador',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Si',
          0: 'No'
        }
      },
      {
        nombre: 'Estado',
        campo: 'estado',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Creado',
          2: 'Ingresado',
          8: 'Anulado',
          9: 'Finalizado',
          6: 'En flujo',
          5: 'Rechazado',
          10: 'Tramitado',
          12: 'Aprobado',
          100: 'Archivado'
        }
      },
      /*
      {
        nombre: 'Es privado',
        campo: 'transportePuertoTipo', // es privado
        tipo: 'multi',
        valor: [],
        opciones: {
            [PRIVACITY.CONFIDENTIAL]: 'Documento privado',
            [PRIVACITY.PUBLIC]: 'Documento público'
        }
      },
      */
      {
        nombre: 'Tipo Expediente',
        campo: 'claseMercadoPublico', // tipo de expedient
        tipo: 'multi',
        valor: [],
        opciones: {
          numInt: 'Numeración interna',
          numOf: 'Numeración oficial',
          ext: 'Externo',
          int: 'Interno'
        }
      },
      {
        nombre: 'Acompaña físico',
        campo: 'transporteViaTransporteCodigoTransporte',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Acompaña físico',
          0: 'No Acompaña físico'
        }
      },
      {
        nombre: 'Tipo de destino',
        campo: 'destinoCodigoIds',
        tipo: 'multi',
        valor: [],
        opciones: {
          usuarios: 'Funcionarios',
          unidades: 'Unidades',
          oficinas: 'Oficinas',
          docDigital: 'DocDigital',
          ministerios: 'Ministerios',
          empresas: 'Empresas',
          personas: 'Personas'
        }
      },
      {
        nombre: 'Tipo de referencia',
        campo: 'codigosReferenciasTipos',
        tipo: 'multi',
        valor: [],
        opciones: {
          EXP: 'Expediente',
          SSD: 'Proceso SSD'
        }
      },
      {
        nombre: 'Fecha documento', campo: 'fechaEmision', tipo: 'fecha', valor: ''
      },
      {
        nombre: 'Nombre remitente', campo: 'emisorContactoNombre', tipo: 'texto', valor: []
      },
      {
        nombre: 'Cargo remitente', campo: 'emisorContactoCargo', tipo: 'texto', valor: []
      },
      {
        nombre: 'Correo remitente', campo: 'emisorContactoEmail', tipo: 'texto', valor: []
      },
      {
        nombre: 'Destino tipo correo', campo: 'destinoCorreoIds', tipo: 'texto', valor: []
      },
      { nombre: 'Derivado por', campo: 'codigosDerivacionUsuario', tipo: 'derivadoIds' },
      { nombre: 'Tipo institución', campo: 'compradorCodigo', tipo: 'opcionInst' },
      { nombre: 'Tipo Documento', campo: 'tiposDocumentos', tipo: 'opcionDoc' },
      { nombre: 'Destino tipo usuario', campo: 'destinoParticipanteIds', tipo: 'usuarioIds' },
      { nombre: 'Destino tipo grupo', campo: 'destinoParticipanteIds', tipo: 'grupoIds' },
      { nombre: 'Usuario creador', campo: 'solicitanteEmail', tipo: 'correos' },
      { nombre: 'Destino Institución Doc Digital', campo: 'destinoInstitucionCodigos', tipo: 'institutionsDD' },
      { nombre: 'Unidad del creador', campo: 'solicitanteGrupoId', tipo: 'grupoCreador' },
      { nombre: 'Unidad del destino', campo: 'destinoListaCodigoUnidad', tipo: 'grupoDestino' },
      { nombre: 'Oficina en flujo', campo: 'aprParticipante', tipo: 'oficinaIds' }
    ]
  },
  'my-files': {
    filtrosFijos: [
      {
        // eslint-disable-next-line no-template-curly-in-string
        nombre: 'Rut emisor', campo: 'emisorRut', tipo: 'text', valor: '${iutEmpresa}'
      },
      {
        nombre: 'Responsable',
        campo: 'destinoResponsableIds',
        tipo: 'text',
        // eslint-disable-next-line no-template-curly-in-string
        valor: '${idUsuario}'
      },
      {
        nombre: 'Tipo',
        campo: 'tipo',
        tipo: 'text',
        valor: 'EXP'
      },
      {
        nombre: 'Estado',
        campo: 'estado',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Creado',
          2: 'Ingresado',
          8: 'Anulado',
          9: 'Finalizado',
          6: 'En flujo',
          5: 'Rechazado',
          10: 'Tramitado',
          12: 'Aprobado',
          100: 'Archivado'
        }
      },
      {
        nombre: 'Tipo expediente',
        campo: 'claseMercadoPublico',
        tipo: 'multi',
        opciones: {
          int: 'Interno',
          ext: 'Externo',
          numInt: 'Num. Interno',
          numOf: 'Num. Oficial'
        }
      },
      {
        nombre: 'Documentos generales$',
        campo: 'general',
        tipo: 'text',
        valor: '0'
      },
    ],
    filtrosHabilitados: [
      {
        nombre: 'Persona remitente', campo: 'despachoContactoNombre', tipo: 'texto', valor: []
      },
      {
        nombre: 'Folio', campo: 'numero', tipo: 'texto', valor: []
      },
      {
        nombre: 'Fecha documento', campo: 'fechaEmision', tipo: 'fecha', valor: ''
      },
      {
        nombre: 'Núm Exp.', campo: 'numero', tipo: 'texto', valor: []
      },
      {
        nombre: 'Núm Doc.', campo: 'numeroInt', tipo: 'texto', valor: []
      },
      {
        nombre: 'Alcance del expediente',
        campo: 'transportePuertoTipo', // es privado
        tipo: 'multi',
        valor: [],
        opciones: {
          [PRIVACITY.RESERVED]: 'Documento reservado',
          [PRIVACITY.CONFIDENTIAL]: 'Documento privado',
          [PRIVACITY.PUBLIC]: 'Documento público'
        }
      },
      {
        nombre: 'Tipo Expediente',
        campo: 'claseMercadoPublico', // tipo de expedient
        tipo: 'multi',
        valor: [],
        opciones: {
          numInt: 'Numeración interna',
          numOf: 'Numeración oficial',
          ext: 'Externo',
          int: 'Interno'
        }
      },
      {
        nombre: 'Estado',
        campo: 'estado',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Creado',
          2: 'Ingresado',
          8: 'Anulado',
          9: 'Finalizado',
          6: 'En flujo',
          5: 'Rechazado',
          10: 'Tramitado',
          12: 'Aprobado',
          100: 'Archivado'
        }
      },
      {
        nombre: 'Acompaña físico',
        campo: 'transporteViaTransporteCodigoTransporte',
        tipo: 'multi',
        valor: [],
        opciones: {
          1: 'Acompaña físico',
          0: 'No Acompaña físico'
        }
      },
      {
        nombre: 'Tipo de destino',
        campo: 'destinoCodigoIds',
        tipo: 'multi',
        valor: [],
        opciones: {
          usuarios: 'Funcionarios',
          unidades: 'Unidades',
          oficinas: 'Oficinas',
          docDigital: 'DocDigital',
          ministerios: 'Ministerios',
          empresas: 'Empresas',
          personas: 'Personas'
        }
      },
      {
        nombre: 'Tipo de referencia',
        campo: 'codigosReferenciasTipos',
        tipo: 'multi',
        valor: [],
        opciones: {
          EXP: 'Expediente',
          SSD: 'Proceso SSD'
        }
      },
      {
        nombre: 'Nombre remitente', campo: 'emisorContactoNombre', tipo: 'texto', valor: []
      },
      {
        nombre: 'Cargo remitente', campo: 'emisorContactoCargo', tipo: 'texto', valor: []
      },
      {
        nombre: 'Correo remitente', campo: 'emisorContactoEmail', tipo: 'texto', valor: []
      },
      {
        nombre: 'Destino tipo correo', campo: 'destinoCorreoIds', tipo: 'texto', valor: []
      },
      { nombre: 'Derivado por', campo: 'codigosDerivacionUsuario', tipo: 'derivadoIds' },
      { nombre: 'Tipo Documento', campo: 'tiposDocumentos', tipo: 'opcionDoc' },
      { nombre: 'Tipo institución', campo: 'compradorCodigo', tipo: 'opcionInst' },
      { nombre: 'Destino tipo usuario', campo: 'destinoParticipanteIds', tipo: 'usuarioIds' },
      { nombre: 'Destino tipo grupo', campo: 'destinoParticipanteIds', tipo: 'grupoIds' },
      { nombre: 'Usuario creador', campo: 'solicitanteEmail', tipo: 'correos' },
      { nombre: 'Destino Institución Doc Digital', campo: 'destinoInstitucionCodigos', tipo: 'institutionsDD' },
      { nombre: 'Unidad del creador', campo: 'solicitanteGrupoId', tipo: 'grupoCreador' },
      { nombre: 'Unidad del destino', campo: 'destinoListaCodigoUnidad', tipo: 'grupoDestino' }
    ]
  },
  presalida: {
    filtrosFijos: [
      {
        nombre: 'Rut emisor',
        campo: 'emisorRut',
        tipo: 'text',
        // eslint-disable-next-line no-template-curly-in-string
        valor: '${iutEmpresa}'
      },
      {
        nombre: 'Tipo',
        campo: 'tipo',
        tipo: 'text',
        valor: 'EXP'
      },
      {
        nombre: 'Tipo de destino',
        campo: 'destinoCodigoIds',
        tipo: 'multi',
        valor: [],
        opciones: {
          docDigital: 'DocDigital'
        }
      },
      {
        nombre: 'Tipo Expediente',
        campo: 'claseMercadoPublico', // tipo de expedient
        tipo: 'multi',
        valor: [],
        opciones: {
          numInt: 'Numeración interna',
          numOf: 'Numeración oficial',
          ext: 'Externo',
          int: 'Interno'
        }
      },
      {
        nombre: 'Enviado a DocDigital',
        campo: 'leidoReceptor',
        tipo: 'text',
        valor: 'N'
      },
      {
        nombre: 'Estado',
        campo: 'estado',
        tipo: 'multi',
        valor: [],
        opciones: {
          10: 'Tramitados'
        }
      }
    ],
    filtrosHabilitados: [
      {
        nombre: 'Fecha documento', campo: 'fechaEmision', tipo: 'fecha', valor: ''
      },
      {
        nombre: 'Núm Exp.', campo: 'numero', tipo: 'texto', valor: []
      },
      {
        nombre: 'Núm Doc.', campo: 'numeroInt', tipo: 'texto', valor: []
      },
      {
        nombre: 'Tipo Expediente',
        campo: 'claseMercadoPublico', // tipo de expedient
        tipo: 'multi',
        valor: [],
        opciones: {
          numInt: 'Numeración interna',
          numOf: 'Numeración oficial',
          ext: 'Externo',
          int: 'Interno'
        }
      },
      {
        nombre: 'Nombre remitente', campo: 'emisorContactoNombre', tipo: 'texto', valor: []
      },
      {
        nombre: 'Cargo remitente', campo: 'emisorContactoCargo', tipo: 'texto', valor: []
      },
      {
        nombre: 'Correo remitente', campo: 'emisorContactoEmail', tipo: 'texto', valor: []
      },
      { nombre: 'Usuario creador', campo: 'solicitanteEmail', tipo: 'correos' }
    ]
  }
};

export default {
  data() {
    return filterViews;
  },
  methods: {
    getFilterViewLetty(view, iutCompany) {
      let filtros = { ...filterViews[view] };
      if (filterViewsCompany[iutCompany] && filterViewsCompany[iutCompany][view]) {
        filtros = {
          filtrosFijos: [
            ...filterViewsCompany[iutCompany][view].filtrosFijos || [],
            ...filtros.filtrosFijos || []
          ],
          filtrosHabilitados: [
            ...filterViewsCompany[iutCompany][view].filtrosHabilitados || [],
            ...filtros.filtrosHabilitados || []
          ]
        };
        if (filterViewsCompany[iutCompany][view].filtroFijoABorrar) {
          filtros = {
            ...filtros,
            filtrosFijos: filtros.filtrosFijos.filter(
              (filtro) => !filterViewsCompany[iutCompany][view].filtroFijoABorrar
                .includes(filtro.campo)
            )
          };
        }
        if (filterViewsCompany[iutCompany][view].filtrosHabilitadosABorrar) {
          filtros = {
            ...filtros,
            filtrosHabilitados: filtros.filtrosHabilitados.filter(
              (filtro) => !filterViewsCompany[iutCompany][view].filtrosHabilitadosABorrar
                .includes(filtro.campo)
            )
          };
        }
      }
      if (filterViewsCompany[iutCompany] && filterViewsCompany[iutCompany].renombres) {
        const { renombres } = filterViewsCompany[iutCompany];
        Object.keys(renombres).forEach((key) => {
          /* eslint-disable no-unused-expressions */
          filtros.filtrosHabilitados?.forEach((filtro) => {
            if (filtro.campo === key) {
              /* eslint-disable no-param-reassign */
              filtro.nombre = renombres[key];
            }
          });
        });
      }
      return filtros;
    }
  }
};
